import { Box, Skeleton, BoxProps } from "@mui/material";
import React from "react";
import clsx from "clsx";
import { useStyles } from "./ClientFormCardItem";

export function ClientFormCardItemSkeleton(props: BoxProps) {
  const s = useStyles();
  const { className, ...other } = props;
  return (
    <Box className={clsx(s.root, className)} {...other}>
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Skeleton variant="text" width={"100%"} />
        <Skeleton variant="text" width={"50%"} />
      </Box>
    </Box>
  );
}
